import * as tslib_1 from "tslib";
import cx from 'classnames';
import * as React from 'react';
import AmCharts from "../AmCharts";
import Styles from "./Charts.css";
import { DEFAULT_SETTINGS, LEGEND_SETTINGS, RESPONSIVE_SETTINGS, VALUE_AXIS_SETTINGS } from './constants';
import Utils from './utils/common';
var DEFAULT_COLOR = '#333333';

var ScatterChart =
/** @class */
function (_super) {
  tslib_1.__extends(ScatterChart, _super);

  function ScatterChart() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getOptions = function () {
      var _a = _this.props,
          title = _a.title,
          data = _a.data,
          unit = _a.unit,
          legendEnabled = _a.legendEnabled,
          legendPosition = _a.legendPosition,
          isDrillingDown = _a.isDrillingDown,
          isSecondLevel = _a.isSecondLevel,
          onGraphItemClick = _a.onGraphItemClick,
          triggerCallRecordingModal = _a.triggerCallRecordingModal,
          timeRange = _a.timeRange,
          disableDownload = _a.disableDownload,
          responsive = _a.responsive;

      var options = tslib_1.__assign({}, DEFAULT_SETTINGS, {
        type: 'xy',
        autoMargins: true,
        dataProvider: data.data,
        balloon: {
          adjustBorderColor: false,
          shadowAlpha: 0
        }
      }); // ------------------------------
      // Graphs
      // ------------------------------


      options.graphs = data.meta.items.map(function (itemName, idx) {
        return {
          title: itemName,
          balloonFunction: _this.balloonFunction,
          bullet: 'circle',
          lineAlpha: 0,
          lineColor: data.meta.itemColors ? data.meta.itemColors[idx] : DEFAULT_COLOR,
          xField: data.meta.categoryField,
          yField: itemName,
          fillAlphas: 0,
          showHandOnHover: !!onGraphItemClick
        };
      }); // ------------------------------
      // Value axis
      // ------------------------------

      var axisProps = tslib_1.__assign({
        axisAlpha: 0,
        dashLength: 1,
        titleBold: false,
        dateFormats: [{
          period: 'fff',
          format: 'L:NN:SS A'
        }, {
          period: 'ss',
          format: 'L:NN:SS A'
        }, {
          period: 'mm',
          format: 'L:NN A'
        }, {
          period: 'hh',
          format: 'L:NN A'
        }, {
          period: 'DD',
          format: 'MMM DD'
        }, {
          period: 'WW',
          format: 'MMM DD'
        }, {
          period: 'MM',
          format: 'MMM'
        }, {
          period: 'YYYY',
          format: 'YYYY'
        }]
      }, VALUE_AXIS_SETTINGS);

      var _b = timeRange ? Utils.getStartEndDates(timeRange) : {
        start: undefined,
        end: undefined
      },
          start = _b.start,
          end = _b.end;

      var minPeriod = 'DD';
      var minDate;
      var maxDate;
      var titleX;
      var titleY = data.meta.y_label || '';

      if (start && end) {
        if (isDrillingDown) {
          if (!isSecondLevel) {
            // drilled down to level 1
            minDate = start.subtract(1, 'hours').toDate();
            maxDate = end.toDate();
            minPeriod = 'L';
            titleY = 'Number of Calls';
          } else {
            // drilled down to level 2
            minDate = start.subtract(5, 'minutes').toDate();
            maxDate = end.add(5, 'minutes').toDate();
            minPeriod = 'mm';
            titleX = 'Start Time';
            titleY = 'Minutes';
          }
        } else {
          // not drilled down
          if (data.meta.dateFormat) {
            minDate = start.subtract(1, 'days').toDate();
            maxDate = end.add(1, 'days').toDate();
          }
        }
      }

      var valueAxis = [tslib_1.__assign({}, axisProps, {
        position: 'bottom',
        title: titleX,
        type: data.meta.x_type || 'numeric',
        minPeriod: minPeriod,
        minimumDate: minDate,
        maximumDate: maxDate,
        centerLabelOnFullPeriod: false,
        labelRotation: 45,
        equalSpacing: false,
        markPeriodChange: false
      }), tslib_1.__assign({}, axisProps, {
        position: 'left',
        title: titleY,
        type: data.meta.y_type || 'numeric'
      })];

      if (unit === 'minutes') {
        options.valueAxes[1].labelFunction = Utils.secondsToMinutes;
      }

      options.valueAxes = valueAxis; // ------------------------------
      // Category axis
      // ------------------------------

      options.categoryField = data.meta.categoryField;
      options.categoryAxis = {};
      var dateFormat = data.meta.dateFormat;

      if (dateFormat) {
        if (dateFormat !== 'auto') {
          options.dataDateFormat = dateFormat;
        }

        options.categoryAxis.parseDates = true;
      } // ------------------------------
      // Legend
      // ------------------------------


      if (legendEnabled) {
        options.legend = tslib_1.__assign({}, LEGEND_SETTINGS, {
          enabled: legendPosition !== 'none',
          position: Utils.getLegendPosition(legendPosition)
        });
      } // ------------------------------
      // Responsive
      // ------------------------------


      if (responsive) {
        options.responsive = tslib_1.__assign({}, RESPONSIVE_SETTINGS, {
          enabled: true
        });
      } // ------------------------------
      // Export
      // ------------------------------


      if (!disableDownload) {
        options.export = Utils.getExportOptions(title, timeRange);
      } // ------------------------------
      // Listeners
      // ------------------------------


      if (onGraphItemClick) {
        options.listeners = [{
          event: 'clickGraphItem',
          method: function method(event) {
            var callType = event.item.graph.title;

            if (!isSecondLevel) {
              // can drill down
              var selectedDateTime = event.item.dataContext.category;

              if (onGraphItemClick) {
                onGraphItemClick(callType, selectedDateTime, isDrillingDown);
              }
            } else {
              // drilled down to level 2
              var callRecordingInfo = event.item.dataContext.rowData;

              if (triggerCallRecordingModal) {
                triggerCallRecordingModal(callRecordingInfo);
              }
            }
          }
        }];
      }

      return options;
    };

    _this.balloonFunction = function (dataItem, graph) {
      var _a = _this.props,
          data = _a.data,
          unit = _a.unit;
      var title = graph.title;
      var category = dataItem.dataContext[data.meta.categoryField];
      var yValue = dataItem.dataContext[graph.yField];

      if (unit === 'minutes') {
        yValue = Utils.humanizeSeconds(yValue);
      }

      return ["<b>" + title + "</b>", category, yValue].join('<br/>');
    };

    return _this;
  }

  ScatterChart.prototype.render = function () {
    var _a = this.props,
        height = _a.height,
        className = _a.className;

    var style = tslib_1.__assign({}, height ? {
      height: height
    } : {});

    var options = this.getOptions();
    return React.createElement("div", {
      className: cx(Styles.scatterChart, className)
    }, React.createElement(AmCharts.React, {
      style: style,
      options: options
    }));
  };

  return ScatterChart;
}(React.PureComponent);

export default ScatterChart;